import * as React from 'react';
import debounce from 'lodash/debounce';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Fade from '@mui/material/Fade';
import {styled} from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import PriorityHighRoundedIcon from '@mui/icons-material/PriorityHighRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

import useTemplateActions from 'pages/Template/hooks/useTemplateActions';
import useTemplateState from 'pages/Template/hooks/useTemplateState';

const ErrorMessage: React.FC = () => {
    const Item = styled(Paper)(({theme}) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
        ...theme.typography.body2,
        margin: '30px',
        padding: '30px',
        textAlign: 'center',
        minWidth: '420px',
    }));

    const {getConnection} = useTemplateActions();
    const {isLoadingConnect} = useTemplateState();

    const DEBOUNCE_MS = 200;

    const handleReload = debounce(() => {
        getConnection();
    }, DEBOUNCE_MS);

    return (
        <Fade in={true}>
            <Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
                <Item>
                    <PriorityHighRoundedIcon color="error" />
                    <h2>Something is wrong</h2>
                    <p>
                        Rate Confirmation confirmation not <br />
                        signed. Please, try later!{' '}
                    </p>
                    <Button
                        variant="contained"
                        onClick={handleReload}
                        disabled={isLoadingConnect}
                        endIcon={<ArrowForwardRoundedIcon />}
                    >
                        SIGN
                    </Button>
                </Item>
            </Stack>
        </Fade>
    );
};

export default ErrorMessage;
